import i18n from "i18next";
import k from "src/i18n/keys";

import { useSelector } from "react-redux";
import React, { useCallback } from "react";
import { toast } from "react-toastify";

import { getWorkflowInstanceFilter, getInstanceReportId } from "src/reducers";
import BlueOutlineButton from "src/components/Buttons/BlueOutline";
import Icon from "src/icons";

import type { AppState } from "src/types";

const Copy = (): React.ReactElement => {
  const filter = useSelector(({ app }: { app: AppState }) =>
    getWorkflowInstanceFilter(app),
  );
  const reportId = useSelector(({ app }: { app: AppState }) =>
    getInstanceReportId(app),
  );

  const handleCopy = useCallback(() => {
    const { page } = filter;
    const textField = document.createElement("textarea");
    textField.innerText = (window.location.href || "")
      .replace(`&page=${page}`, "")
      .replace(`page=${page}`, "");

    if (document.body) {
      document.body.appendChild(textField);
    }
    textField.select();
    document.execCommand("copy");
    textField.remove();

    const tableType = reportId ? "Report" : "Process";
    toast.success(`Copied your current ${tableType} table view`);
  }, [filter, reportId]);

  return (
    <BlueOutlineButton
      leftIcon={<Icon type="copy" fill="#2F80ED" />}
      onClick={handleCopy}
    >
      {i18n.t(k.COPY)}
    </BlueOutlineButton>
  );
};

export default Copy;
